/**
 * Masks the local part of an email for the order-confirmation line, e.g.
 * `yemismail92@email.com` → `yem•••92@email.com`. Local parts of 5 chars or
 * fewer are left intact (nothing meaningful to hide). Returns "" for a missing
 * email and the input unchanged when there is no `@`.
 */
export const maskEmail = (email: string | undefined): string => {
  if (!email) return "";
  const at = email.lastIndexOf("@");
  if (at <= 0) return email;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  const masked =
    local.length <= 5 ? local : `${local.slice(0, 3)}•••${local.slice(-2)}`;
  return `${masked}@${domain}`;
};
